import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import DeleteModal from 'src/components/DeleteModal';
import { addToast, clearToasts } from 'src/components/Toast';
import { deleteNews, editNews, fetchNewsDetails } from 'src/helpers/api';
import { usePageModals } from 'src/shared/Modal';
import AdminNewsForm, {
  IAdminNewsFormSubmitValues,
  IAdminNewsFormValues
} from './components/NewsForm';
import { useAdminNews } from './Context';

interface IAdminNewsParams {
  id: string;
}

const AdminNewsEdit = (props: RouteComponentProps<IAdminNewsParams>) => {
  const modals = usePageModals();
  const [values, setValues] = React.useState<IAdminNewsFormValues>({});
  const { params } = props.match;
  const id = parseInt(params.id, 10);
  const news = useAdminNews();
  const handleEdit = async (valuesFromForm: IAdminNewsFormSubmitValues) => {
    try {
      await editNews(id, valuesFromForm);
      clearToasts();
      addToast({ type: 'info', message: 'Nyheden er opdateret' });
      news.fetchList(news.page);
    } catch (error) {
      addToast({ type: 'error', message: 'Der opstod en fejl' });
    }
  };

  const handleDelete = () => {
    modals.open((modal) => (
      <DeleteModal
        onDelete={async () => {
          try {
            await deleteNews(id);
            addToast({ type: 'info', message: 'Nyheden er slettet' });
            news.fetchList(news.page);
            props.history.push('/cms/nyheder');
          } catch (error) {
            addToast({ type: 'error', message: 'Der opstod en fejl' });
          }
        }}
        onCancel={modal.close}
        onClose={modal.close}
        deleteButtonText="Ja - slet nyhed"
        cancelButtonText="Nej - tilbage til nyheden"
        title={<>
          {'Du har valgt at slette denne nyhed.'}
          <br />
          {'Er det korrekt?'}
        </>}
      />
    ))
  };

  React.useEffect(() => {
    fetchNewsDetails(id).then(item => {
      setValues({
        newsId: id,
        title: item.title,
        newsDate: item.publishedAt,
        newsDateExpire: item.expiresAt,
        content: item.content || '',
        newsLabel: item.newsLabel || ''
      });
    });
  }, [props.match.params]);

  return (
    <div className="has-background-white relative flex-1 p-14">
      <h2 className="uppercase font-light f4 mt-0 mb-5">Rediger nyhed</h2>
      <AdminNewsForm
        values={values}
        onCancel={() => props.history.push('/cms/nyheder')}
        onSubmit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default AdminNewsEdit;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/AdminNews/Edit.tsx